/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../widgets/livewidget/nls/StringResources',
	'underscore',
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../api/SlotActionsProviderAPI',
	'../../../../apiHelpers/SlotAPIHelper',
	'./TopBottomActionAPI'
], function(stringResources, _, APIFactory, SlotActionsProviderAPI, SlotAPIHelper, TopBottomActionAPI) {

	return class TopBottomAction {

		constructor({ content, dashboardAPI, features }) {
			this.content = content;
			this.dashboardApi = dashboardAPI;
			this.features = features;
			this.content.getFeature('SlotActions').registerProvider('topBottomAction', this.getAPI());
		}

		getSlotActionList(dataSlotId, itemIndex) {

			let dataSlot = this.getVisualization().getSlots().getSlot(dataSlotId);

			if (dataSlot && SlotAPIHelper.isSlotTopBottomable(this.getVisualization().getDefinition(), dataSlot, itemIndex)) {
				this.slot = dataSlot;
				const slotId = dataSlot.getDefinition().getId();
				this.dataItemIndex = itemIndex ? parseInt(itemIndex) : 0;
				this.dataItem = this.slot.getDataItemList()[this.dataItemIndex];

				let viewOptions = this.getViewState();
				viewOptions.getTopBottomState = this.dataItem.getTopBottom.bind(this);
				viewOptions.contextColumns = this._isAttribute() && this._getFactColumns();
				viewOptions.allowPercentOperations = this._isAttribute();
				viewOptions.allowRankColumn = this.getVisualization().getDefinition().getId() === 'JQGrid';
				viewOptions.onSearch = this._onSearch.bind(this);
				const topbottomIcon = this.features['Dashboard.Icons'].getIcon('dashboard-topbottom');
				return [{
					name: 'topBottomAction',
					targetCaption: this.dataItem.getLabel(),
					label: stringResources.get('toolbarActionTopBottom'),
					icon: topbottomIcon.id,
					type: 'NextView',
					view: {
						module: 'dashboard-analytics/lib/@waca/dashboard-common/dist/ui/dialogs/TopBottomDialog',
						state: viewOptions
					},
					actions: {
						apply: this.applyTopBottomValues.bind(this, slotId, itemIndex),
						reset: this.reset.bind(this, slotId, itemIndex)
					}
				}];
			}
			return [];
		}

		_getFactColumns() {
			return _.unique(this.getVisualization().getDataSource().findMetadataColumns('','fact'));
		}

		_onSearch(searchTerm){
			return _.unique(this.getVisualization().getDataSource().findMetadataColumns(searchTerm, 'fact'));
		}

		getViewState() {
			if(this.slot) {
				let options = {
					height: 280,
					width: 400 // those are hints only; for the placement of the toolbar.
				};
				return options;
			}
			return null;
		}

		_isAttribute() {
			return this.dataItem.getType() === 'attribute' && this.dataItem.getMetadataColumn() && this.dataItem.getMetadataColumn().getType() === 'attribute';
		}

		_addAggregateToContext(state) {
			const contextColumnId = state.context && state.context.itemId;
			if (!contextColumnId) {
				// Do not add aggregation to context if without context 
				return;
			}
			const dataItemList = this.getVisualization().getSlots().getDataItemList();
			if(dataItemList && dataItemList.length > 0) {
				// Don't use an item that is not aggregated as the context item for topbottom. Its not supported.
				// Fallback to other items which are aggregated or the default column aggregation type.
				let dataItem = dataItemList.find(item => item.getColumnId() === contextColumnId && item.getAggregation() !== 'none');
				let contextItemAggregate;
				if(dataItem) {
					contextItemAggregate = dataItem.getAggregation();
				} else {
					// Assign context item default aggregation type if is not projected but with context column
					const contextColumn = this.getVisualization().getDataSource().getMetadataColumn(contextColumnId);
					contextItemAggregate = contextColumn && contextColumn.getDefaultAggregation();
				}

				if(contextItemAggregate) {
					state.context.aggregate = contextItemAggregate;
				}
			}
		}

		applyTopBottomValues(dataSlotId, itemIndex, state) {
			itemIndex = itemIndex || 0;
			this.slot = this.getVisualization().getSlots().getSlot(dataSlotId);
			this.dataItem = this.slot.getDataItemList()[itemIndex];

			if (state) {
				this._addAggregateToContext(state);
				this.dataItem.setTopBottom(state);
			} else {
				this.dataItem.setTopBottom();
			}
		}

		reset(dataSlotId, itemIndex) {
			this.slot = this.getVisualization().getSlots().getSlot(dataSlotId);
			this.dataItem = this.slot.getDataItemList()[itemIndex];
			this.applyTopBottomValues(dataSlotId, itemIndex);
		}

		getVisualization() {
			if(!this.visualization) {
				this.visualization = this.content.getFeature('Visualization');
			}
			return this.visualization;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [SlotActionsProviderAPI, TopBottomActionAPI]);
			}
			return this._api;
		}
	};
});
